export const getIterativeProps = (record: any, dataIndexes?: string | string[]): any => {
	if (!dataIndexes) {
		return record;
	}

	if (!Array.isArray(dataIndexes)) {
		return record[dataIndexes];
	}

	if (dataIndexes.length === 1) {
		return record[dataIndexes[0]];
	}

	return getIterativeProps(record[dataIndexes[0]], dataIndexes.slice(1));
};
